<!--
 * @Author: Tina Huang
 * @Date: 2024-01-12 15:20:28
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-23 10:46:45
 * @Description: 
-->
<template>
  <div>
    <h2>Notion模版库</h2>
    <!-- <el-alert
      class="use"
      title="模版使用方式：点击「拷贝模版」打开模版链接，点击右上角「Duplicate」按钮拷贝到自己的空间"
      type="info"
      center
      show-icon
    ></el-alert> -->
    <div class="selector">
      分类：
      <el-radio-group v-model="tempType">
        <el-radio label="all">全部</el-radio>
        <el-radio label="free">免费模版（{{ freeList.length }}）</el-radio>
        <el-radio label="pay">付费模版（{{ payList.length }}）</el-radio>
      </el-radio-group>
      <span style="margin-left: 50px">搜索：</span>
      <el-input
        placeholder="请输入关键词"
        v-model="search"
        class="input-with-select"
        suffix-icon="el-icon-search"
      >
      </el-input>
      <router-link :to="{ name: 'pro' }">
        <el-button
          type="warning"
          size="small"
          style="margin-left: 25px"
          data-splitbee-event="Be VIP"
          >成为会员领取所有模版</el-button
        >
      </router-link>
    </div>
    <div class="template-list">
      <div
        class="item"
        :class="item.direction"
        v-for="item in showList"
        :key="item.title"
        @click="handleTempClick(item)"
      >
        <div class="fix">
          <el-tag v-if="item.code" effect="dark" type="warning" size="small"
            >限定分享</el-tag
          >
        </div>
        <el-image class="cover" :src="item.cover" lazy></el-image>
        <div class="info">
          <h3>
            {{ item.title }}
            <el-tag
              v-if="!item.forward && item.pay && item.direction === 'row'"
              effect="dark"
              type="danger"
              size="small"
              >{{
                item.pay ? `¥ ${item.pay}${item.has_specs ? " 起" : ""}` : ""
              }}</el-tag
            >
          </h3>
          <p>{{ item.description }}</p>
        </div>
        <template v-if="item.forward">
          <el-button
            class="copy-btn"
            type="success"
            plain
            round
            icon="el-icon-top-right"
            @click.stop="handleCopy(item)"
            >{{ "Coming soon" }}</el-button
          >
        </template>
        <template v-else-if="item.pay">
          <el-tag
            v-if="item.pay && item.direction === 'col'"
            effect="dark"
            type="danger"
            size="small"
            class="col-price"
            >{{ item.pay ? `¥ ${item.pay}` : "" }}</el-tag
          >
          <el-button
            class="copy-btn"
            type="warning"
            plain
            round
            icon="el-icon-top-right"
            @click="handleCopy(item)"
            >{{ "去购买" }}</el-button
          >
        </template>
        <template v-else-if="item.lock">
          <el-button
            class="copy-btn"
            type="primary"
            plain
            round
            icon="el-icon-lock"
            :disabled="true"
            >{{ "已锁定" }}</el-button
          >
        </template>
        <template v-else-if="!isLogin">
          <el-button
            class="copy-btn"
            type="primary"
            plain
            round
            icon="el-icon-top-right"
            @click.stop="handleNologinCopy(item)"
            >{{ "去拷贝" }}</el-button
          >
        </template>
        <el-button
          class="copy-btn"
          type="primary"
          plain
          round
          icon="el-icon-top-right"
          v-else
          data-splitbee-event="Duplicate template"
          @click.stop="handleLinkCopy(item)"
          >{{ "去拷贝" }}</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import tool from "../../lib/index.js";
export default {
  data() {
    return {
      list: [],
      freeList: [],
      payList: [],
      tempType: "all",
      search: "",
      isLogin: tool.isLogin(this.$token),
    };
  },
  mounted() {
    this.getDatas();
  },
  computed: {
    showList() {
      let _list = this.list;
      if (this.tempType === "free") _list = this.freeList;
      else if (this.tempType === "pay") _list = this.payList;
      const _search = this.search.toLowerCase();
      if (this.search) {
        _list = _list.filter(
          (item) =>
            item.title.toLowerCase().indexOf(_search) > -1 ||
            item.description.toLowerCase().indexOf(_search) > -1
        );
      }
      return _list;
    },
  },
  methods: {
    getDatas() {
      const _this = this;
      this.$axios.get(`./picks.json?v=${Math.random()}`).then((res) => {
        let list = res.data.filter((x) => !x.hide);
        let freeList = list.filter((x) => !x.pay && !x.forward);
        let payList = list.filter((x) => x.pay && !x.forward);
        _this.list = list;
        _this.freeList = freeList;
        _this.payList = payList;
      });
    },
    handleTempClick(item) {
      if (item.forward)
        return this.$message({
          message: "模版建设中，敬请期待",
          type: "success",
        });
      if (item.pay) return this.handleCopy(item);
      if (item.lock) return;
      else if (!this.isLogin) return this.handleNologinCopy(item);
      else if (item.link.includes("http")) {
        window.open(item.link, "_blank");
      } else {
        this.$router.push({ name: "mpicks_get", params: { type: "code" } });
      }
    },
    // 购买模版
    handleCopy(item) {
      splitbee.track("Buy template", {
        title: item.title,
      });
      if (item.forward)
        return this.$message({
          message: "模版建设中，敬请期待",
          type: "success",
        });
      this.$router.push({ name: "paid", params: { id: item.id } });
    },
    handleNologinCopy(item) {
      const _this = this;
      this.$message({
        message: "输入口令拷贝模版",
        type: "warning",
      });
      splitbee.track("Copy template without logining", {
        title: item.title,
      });
      this.$code({
        successGo() {
          console.log("login success");
          _this.isLogin = true;
        },
      });
    },
    handleLinkCopy(item) {
      if (item.link.includes("http")) {
        window.open(item.link);
      } else {
        this.$router.push({ path: item.link });
      }
    },
  },
};
</script>
<style lang="less" scoped>
h2 {
  font-size: 30px;
  text-align: center;
}
.template-list {
  padding-top: 50px;
  display: flex;
  flex-wrap: wrap;
  //   flex-direction: column;
  // justify-content: space-between;
  margin-left: -40px;
  // justify-content: space-around;
  .item {
    display: flex;
    width: 400px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 10%);
    margin-bottom: 14px;
    position: relative;
    margin-left: 40px;
    cursor: pointer;
    h3 {
      font-size: 20px;
      margin: 14px 0;
      display: flex;
      align-items: center;
      position: relative;
      .el-tag {
        margin-left: 5px;
        // position: absolute;
      }
    }
    p {
      font-size: 16px;
      margin: 25px 0;
    }
    .copy-btn {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
    .fix {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 111;
    }
    &.col {
      .cover {
        width: 200px;
        height: 100%;
        display: inline-block;
      }
      .info {
        width: 200px;
        height: 100%;
        box-sizing: border-box;
        padding: 14px;
      }
    }
    &.row {
      flex-direction: column;
      .cover {
        width: 100%;
        height: 170px;
        display: block;
        margin: 0 auto;
        object-fit: fill;
      }
      .info {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 14px;
        p {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .copy-btn {
        bottom: 58px;
      }
    }
  }
}
.card-tag {
  margin-right: 10px;
}
.selector {
}

.col-price {
  position: absolute;
  right: 0;
}

.input-with-select {
  width: 300px;
  display: inline-block;
}
</style>